import { Link as RouterLink, useLocation } from "react-router-dom";
import { Button, EmptyState, Stack } from "@app/ui-kit";
import { useShell } from "../components/ShellContext";

/**
 * An unknown address under a client portal says so and points at that client's applications. Before this the shell's
 * catch-all sent it to "/", which resolved a BKDP administrator to the admin console with no message: a mistyped
 * application address landed in the wrong building, silently.
 */
export const ClientNotFound = () => {
  const { client } = useShell();
  const { pathname } = useLocation();
  const home = client ? `/c/${client.slug}` : "/";
  return (
    <Stack spacing={3} sx={{ maxWidth: 640 }}>
      <EmptyState
        eyebrow="Not found"
        title="There is nothing at this address"
        description={`${pathname} is not a page in ${client?.name ?? "this portal"}. Applications live under ${home}/apps/<application>; the list of them is on the home page.`}
        action={<Button component={RouterLink} to={home} variant="contained" data-testid="back-to-apps">Back to the applications</Button>}
      />
    </Stack>
  );
};
